export const FILTERS_STORAGE_KEY = 'neobox:filters';
export const FILTERS_EVENT = 'neobox:filters';
